import {
  OrderItemStatus,
  PointsTransactionModel,
  PollingData,
  TransactionStatus,
} from '@rd/types';
import {
  Order,
  OrderIndexParamsItemType,
  OrderIndexParamsStatus,
  OrderManageQueryParams,
} from '@rd/types/order.type';

export const constructOrderListingQueryParams = (
  queryParams: any,
  defaultQueryParam: any = { sort: '-created_at' },
): OrderManageQueryParams => {
  let finalOrderItemType: OrderManageQueryParams['orderItemType'];
  let finalSort: OrderManageQueryParams['sort'];
  let finalStatus: OrderManageQueryParams['status'];

  const { status, orderItemType, sort } = queryParams;

  // Changes sort=hello => sort=created_at
  if (['-created_at', 'created_at'].includes(sort)) {
    finalSort = sort;
  } else {
    finalSort = defaultQueryParam.sort;
  }

  // Remove non-existent statuses from status query param
  if (!!status) {
    finalStatus = status
      .split(',')
      .filter((allowedStatus: OrderIndexParamsStatus) =>
        ['completed', 'processing', 'cancelled', 'failed'].includes(
          allowedStatus,
        ),
      )
      .join(',');
  }

  // Remove non-existent statuses from orderItemType query param
  if (!!orderItemType) {
    finalOrderItemType = orderItemType
      .split(',')
      .filter((allowedOrderItemType: OrderIndexParamsItemType) =>
        [
          'giftCard',
          'pointsTransfer',
          'merchandise',
          'cashRedemption',
          'retail',
        ].includes(allowedOrderItemType),
      )
      .join(',');
  }

  return {
    // @ts-ignore
    status: finalStatus || '',
    // @ts-ignore
    orderItemType: finalOrderItemType || '',
    sort: finalSort,
  };
};

export function getCombinedOrderTransactionStatus(params: {
  loading: boolean;
  error: boolean;
  order?: Order;
  pollingData?: PollingData;
}): TransactionStatus {
  const { loading, error, order, pollingData } = params;
  if (error) {
    return TransactionStatus.FAIL;
  }
  if (loading) {
    return TransactionStatus.LOADING;
  }
  if (pollingData?.status === TransactionStatus.POLLING) {
    return TransactionStatus.POLLING;
  }
  if (pollingData?.status === TransactionStatus.SUCCESS || !!order) {
    return TransactionStatus.SUCCESS;
  }
  return TransactionStatus.LOADING;
}

export function getOrderItemStatus(
  orderItemStatus: OrderItemStatus,
): OrderItemStatus {
  switch (orderItemStatus) {
    case OrderItemStatus.Processing:
      return OrderItemStatus.Pending;
    case OrderItemStatus.Failed:
      return OrderItemStatus.Cancelled;
  }
  return orderItemStatus;
}

// Append orderId if it's available. Not all PointsTransactions have an Order Id
// Those with Order Id: GC, PT, RC. Those without: Manual Adjustment, CardSpend.
export function getOrderId(
  relationships: PointsTransactionModel['relationships'],
): string | undefined {
  return relationships?.order?.data.id ?? undefined;
}
